const userId = (user) =>
  user?.mimic ? user.mimic.contact_id : user?.contact_id;
const userEmail = (user) =>
  user?.mimic ? user.mimic.email_address : user?.email_address;

export default {
  userId,
  userEmail,
};
